var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#calendar-check';
                    var viewUrl = 'svg/icons.svg#view-calendar-check';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };